var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["@naturehouse/design-system/components/atoms/image/Image.macro.njk"] = require( "@naturehouse/design-system/components/atoms/image/Image.macro.njk" );
dependencies["@naturehouse/design-system/components/atoms/button/Button.macro.njk"] = require( "@naturehouse/design-system/components/atoms/button/Button.macro.njk" );




var shim = require("/symfony/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["design-system/src/components/molecules/carousel/simple-carousel/SimpleCarousel.html.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("@naturehouse/design-system/components/atoms/image/Image.macro.njk", false, "design-system/src/components/molecules/carousel/simple-carousel/SimpleCarousel.html.njk", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("imageTemplate", t_1);
output += "\n";
env.getTemplate("@naturehouse/design-system/components/atoms/button/Button.macro.njk", false, "design-system/src/components/molecules/carousel/simple-carousel/SimpleCarousel.html.njk", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
context.setVariable("buttonTemplate", t_4);
output += "\n\n";
var t_7;
t_7 = {"name": "arrow-left","size": 1.5};
frame.set("leftArrow", t_7, true);
if(frame.topLevel) {
context.setVariable("leftArrow", t_7);
}
if(frame.topLevel) {
context.addExport("leftArrow", t_7);
}
output += "\n";
var t_8;
t_8 = {"name": "arrow-right","size": 1.5};
frame.set("rightArrow", t_8, true);
if(frame.topLevel) {
context.setVariable("rightArrow", t_8);
}
if(frame.topLevel) {
context.addExport("rightArrow", t_8);
}
output += "\n\n<div class=\"swiper\" data-role=\"simple-carousel\">\n    <ul class=\"swiper-wrapper\">\n        ";
frame = frame.push();
var t_11 = runtime.contextOrFrameLookup(context, frame, "slides");
if(t_11) {t_11 = runtime.fromIterator(t_11);
var t_10 = t_11.length;
for(var t_9=0; t_9 < t_11.length; t_9++) {
var t_12 = t_11[t_9];
frame.set("slide", t_12);
frame.set("loop.index", t_9 + 1);
frame.set("loop.index0", t_9);
frame.set("loop.revindex", t_10 - t_9);
frame.set("loop.revindex0", t_10 - t_9 - 1);
frame.set("loop.first", t_9 === 0);
frame.set("loop.last", t_9 === t_10 - 1);
frame.set("loop.length", t_10);
output += "\n            <li class=\"swiper-slide\">\n                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") == 1) {
output += "\n                    <img\n                        src=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),"src"), env.opts.autoescape);
output += "\"\n                        alt=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),"alt"), env.opts.autoescape);
output += "\"\n                        sizes=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),"sizes"), env.opts.autoescape);
output += "\"\n                        srcset=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),"srcset"), env.opts.autoescape);
output += "\"\n                        width=\"";
output += runtime.suppressValue(env.getFilter("default").call(context, runtime.memberLookup((t_12),"width"),""), env.opts.autoescape);
output += "\"\n                        height=\"";
output += runtime.suppressValue(env.getFilter("default").call(context, runtime.memberLookup((t_12),"height"),""), env.opts.autoescape);
output += "\"\n                        ";
output += "\n                        loading=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "loading"), env.opts.autoescape);
output += "\"\n                        data-loaded=\"true\"\n                    />\n                ";
;
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") == 2) {
output += "\n                    <img\n                        src=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),"src"), env.opts.autoescape);
output += "\"\n                        alt=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),"alt"), env.opts.autoescape);
output += "\"\n                        sizes=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),"sizes"), env.opts.autoescape);
output += "\"\n                        loading=\"lazy\"\n                        width=\"";
output += runtime.suppressValue(env.getFilter("default").call(context, runtime.memberLookup((t_12),"width"),""), env.opts.autoescape);
output += "\"\n                        height=\"";
output += runtime.suppressValue(env.getFilter("default").call(context, runtime.memberLookup((t_12),"height"),""), env.opts.autoescape);
output += "\"\n                        data-srcset=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),"srcset"), env.opts.autoescape);
output += "\"\n                    />\n                ";
;
}
else {
output += "\n                    <img\n                        src=\"\"\n                        alt=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),"alt"), env.opts.autoescape);
output += "\"\n                        sizes=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),"sizes"), env.opts.autoescape);
output += "\"\n                        width=\"";
output += runtime.suppressValue(env.getFilter("default").call(context, runtime.memberLookup((t_12),"width"),""), env.opts.autoescape);
output += "\"\n                        height=\"";
output += runtime.suppressValue(env.getFilter("default").call(context, runtime.memberLookup((t_12),"height"),""), env.opts.autoescape);
output += "\"\n                        data-src=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),"src"), env.opts.autoescape);
output += "\"\n                        data-srcset=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),"srcset"), env.opts.autoescape);
output += "\"\n                    />\n                ";
;
}
;
}
output += "\n                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") > 1) {
output += "\n                    <span class=\"swiper-lazy-preloader swiper-lazy-preloader-white\"></span>\n                ";
;
}
output += "\n            </li>\n        ";
;
}
}
frame = frame.pop();
output += "\n    </ul>\n    <div class=\"swiper-button-prev\">\n        ";
output += runtime.suppressValue((lineno = 56, colno = 32, runtime.callWrap(runtime.memberLookup((t_4),"render"), "buttonTemplate[\"render\"]", context, [{"variant": "dark","icon": runtime.contextOrFrameLookup(context, frame, "leftArrow"),"data": {"data-role": "prev"}}])), env.opts.autoescape);
output += "\n    </div>\n    <div class=\"swiper-button-next\">\n        ";
output += runtime.suppressValue((lineno = 65, colno = 32, runtime.callWrap(runtime.memberLookup((t_4),"render"), "buttonTemplate[\"render\"]", context, [{"variant": "dark","icon": runtime.contextOrFrameLookup(context, frame, "rightArrow"),"data": {"data-role": "next"}}])), env.opts.autoescape);
output += "\n    </div>\n    <div class=\"swiper-pagination\" data-role=\"swiper-pagination\"></div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["design-system/src/components/molecules/carousel/simple-carousel/SimpleCarousel.html.njk"] , dependencies)